import React, {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

//actions:
import {settingsActions} from "../../../../redux/Settings/settingsRedux";

//components:
import {MultipleSelect, BarsChart} from "../../../../widgets";
import {CircularProgress} from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import {loadUserParameter} from "../../../../redux_slices/contextSlice";

const TopicsEvolution = () => {
    const {t} = useTranslation();

    //redux:
    const dispatch = useDispatch();
    //store:
    const language = useSelector(state => loadUserParameter(state, "language"));
    const {
        metricsConcepts: {series, labels},
        metricsConceptsError,
        isLoadingConcepts,
    } = useSelector(state => state.settings);

    //local state:
    const [selectedConcepts, setSelectedConcepts] = useState([{data: []}]);

    useEffect(() => {
        dispatch(settingsActions.getMetricsConcepts(language || "en-US"));
    }, []);

    return (
        <div className="card card-custom gutter-b shadow">
            <div className="card-header pt-6 pb-0 border-bottom border-gray">
                <div className="card-title">{t("ADMINPANEL.METRICS.EVOLUTION_TOPICS_TITLE")}</div>
            </div>

            <div className="card-body position-relative min-h-180px">
                {isLoadingConcepts ? (
                    <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100">
                        <CircularProgress />
                    </div>
                ) : metricsConceptsError?.text ? (
                    metricsConceptsError?.text === "No tracks" ? (
                        <div className="alert alert-light text-dark w-fit-content">
                            {t("ADMINPANEL.METRICS.EMPTY_MESSAGE")}
                            <Link to={"/adminpanel/tracks"}>{t("ADMINPANEL.TRACKS_MANAGEMENT")}</Link>
                        </div>
                    ) : (
                        <div
                            className={`alert alert-${metricsConceptsError.type ||
                                "warning"} font-weight-bold w-fit-content d-flex align-items-center`}
                        >
                            <WarningRoundedIcon color="inherit" className="mr-5" />
                            {metricsConceptsError.text}
                        </div>
                    )
                ) : null}

                <div className="d-flex pb-4 px-9">
                    <MultipleSelect
                        label={t("ADMINPANEL.METRICS.EVOLUTION_TOPICS.SELECTOR.PLACEHOLDER")}
                        options={series}
                        setSelectedOptions={setSelectedConcepts}
                        selectedOptions={selectedConcepts}
                    />
                </div>
                <div className="d-flex min-h-350px w-100 justify-content-center align-items-center position-relative">
                    <BarsChart series={selectedConcepts} categories={labels} />
                </div>
            </div>
        </div>
    );
};

export default TopicsEvolution;
